<app-dialog
  [title]="data.title"
  (close)="close()"
  (action)="action($event)"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Save', isDisabled: scanForm.invalid , spin: spinLoader }
  ]"
>
  <div class="scan-form" [formGroup]="scanForm">
    <div class="input-container">
      <label class="input-container_label" for="">Search Item</label>
      <div class="input-container_wrapper">
        <div class="input-wrapper">
          <input [ngClass]="{ 'error-input': itemMsg }"
          type="text"
          aria-label="Number"
          class="input-container_input"
          formControlName="item"
          [matAutocomplete]="auto"
          (keyup)="onSelectionChange($event.key)"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSelectionChange($event.option.value)">
          <mat-option
            *ngFor="let option of filteredOptionsItem$ | async"
            [value]="option.vendorItemName"
            class="mat-option-override"
          >
            <app-item-typeahead
              [name]="option.vendorItemName"
            ></app-item-typeahead>
          </mat-option>
        </mat-autocomplete>
        <div class="input-container_error-message">
            {{itemMsg}}
        </div>
        </div>
        <span class="mt-3"> Or</span>
        <div (click)="scanInto = scanInto === 'item' ? null : 'item'">
           <app-button [buttonColor]="scanInto === 'item' ? 'success' : 'primary'"> 
            <span [ngClass]="{ 'scan-item': scanInto === 'item' }">Scan</span> 
            </app-button>
      </div>
      </div>
    </div>
    <div class="input-container">
      <label class="input-container_label" for="">Search Location</label>
      <div class="input-container_wrapper">
        <div class="input-wrapper">
          <input [ngClass]="{ 'error-input': locationMsg }"
          class="input-container_input"
          type="text"
          formControlName="location"
          placeholder="Search"
          [matAutocomplete]="autocomp"
         />
         <div class="input-container_error-message">
          {{locationMsg}}
       </div>
       <mat-autocomplete #autocomp="matAutocomplete" [displayWith]="displayWith">
        <mat-option
         *ngFor="let option of filteredOptionsLocation$ | async"
         [value]="option"
         class="mat-option-override"
         >
           <app-item-typeahead
             [name]="option.name"
           ></app-item-typeahead>
         </mat-option>
       </mat-autocomplete> 
        </div>
         <span class="mt-3">Or</span>
         <div (click)="scanInto = scanInto === 'location' ? null : 'location'">
            <app-button [buttonColor]="scanInto === 'location' ? 'success' : 'primary'">
              <span [ngClass]="{ 'scan-item': scanInto === 'location' }">Scan</span>
           </app-button>
          </div>
      </div>
    </div>
    <div class="input-container">
      <label class="input-container_label" for="">Quantity</label>
      <input
        class="input-container_input quantity-input"
        type="number"
        [min]="1"
        [max]="data.data.items ? data.data.qty : ''"
        formControlName="qty"
      />
    </div>
  </div>
</app-dialog>
